import { getTextPrefabList } from '../../../workbench/layer/text/prefab'
import {
  isAudio,
  isEmptyNode,
  isImage,
  isSequenceFrame,
  isText,
  isVideo,
} from '@ps/bridge/qc/base'
import actions from './actions'
import {
  categoryList,
  imageTabList,
  effectSubCategories,
} from '@ps/store/workbench/resource-manager/config'
import { isDragonBoneChild } from '@ps/utils/game'
import i18n from '@/lang'
import { hasWidgetLib } from '../visual-program/utils'
function isParticleImage(category, subCategory) {
  return (
    category === categoryList.effect.category &&
    subCategory === effectSubCategories.particleImage
  )
}

const defaultPoolTabData = {
  poolTabList: [],
  currentTab: '',
  currentChildTab: '',
  rules: [],
  targetNode: null,
  playComponentResource: false,
}

const getInitState = () => {
  return {
    dialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '88px',
      onReplaced: () => {},
    },
    libDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '88px',
      onReplaced: () => {},
    },
    resourcePoolDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '88px',
      onReplaced: () => {},
    },
    // 互动元件弹窗配置
    ivUnitDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '48px',
      onReplaced: () => {},
    },
    debugDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '700px',
      top: '48px',
      onReplaced: () => {},
    },
    /**
     * 资源池内tab展示的内容
     * @param poolTabList tab展示名称数组 ['resourcePool','commonResource']
     * @param currentTab 首层tab的默认值，不设置使用首位的key  libTabNameList枚举数据
     * @param currentChildTab 类型tab的默认值，不设置使用首位的key  all、video、audio、bgm、image、aImage、effect
     * @param rules 允许选择的类型资源
     * 数据来源'@ps/store/workbench/resource-manager/config'中categoryList
     */
    poolTabData: {
      ...defaultPoolTabData,
    },
    dialogStyle: {
      left: '',
      right: '',
    },
    libDialogStyle: {
      left: '',
      right: '',
    },
    layoutDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '312px',
      top: '88px',
      onReplaced: () => {},
    },
    categoryList: categoryList,
    currentCategory: categoryList.image,
    components: {
      name: '',
      list: [],
    }, // 资源列表（非资源库）
    hotCommonComponents: [], // 资源库热门资源
    hotTagComponents: [], // 资源库热门标签
    assistTag: {}, // 辅助标签
    searchTagId: '',
    searchTagType: '',
    filterSearchTag: [],
    textList: getTextPrefabList(),
    tagList: [],
    // 操作行为，add 新增、update 更新，根据该值决定是新增还是更新
    action: 'add',
    subCategory: '', // 子分类，如图片的有 bg 的子分类
    loading: false,
    query: {
      page: 1,
      page_size: 50,
      keyword: '', // 搜索关键字
    },
    noMore: false,
    currentTab: {}, // 当前 tab
    resourceType: 0, // 当前列表对应的资源库类型
    tagId: 0, // 当前列表对应的某个类型资源库的 tagid
    xlzCache: {},
    currentCommonComponentsInfo: {
      // name: '',
      // id: ''
    }, // 组件信息，用在公共
    assetsDialog: {
      visible: false,
      checkbox: false,
      loading: false,
      model: {},
      message: '',
      rules: {},
    },
    freeSize: 0,
    totalSize: 0,
    usedSize: 0,
    totalAssets: 0,
    // 下架字体弹框数据
    forbiddenFontDialog: {
      visible: false,
      loading: false,
      forbiddenFontList: {},
      fontOptions: [],
      message: i18n.t('playTurbo.common.fontForbidden.msgDialog'),
      assetFontConfig: { list: true },
    },
    // 资源节点关系表
    resourceToNodePool: {
      // 资源路径：节点uuid[]
    },
    // 资源池替换资源
    replaceResourcePoolItem: {},
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  getters: {
    currentNodeCategory(state, getters, rootState) {
      const activeNode = rootState.workspace.game.activeNode
      if (!activeNode) return ''
      if (isSequenceFrame(activeNode)) return categoryList.effect.category
      if (isDragonBoneChild(activeNode)) return categoryList.image.category
      if (isImage(activeNode)) return categoryList.image.category
      if (isVideo(activeNode)) return categoryList.video.category
      if (isText(activeNode)) return categoryList.text.category
      if (isEmptyNode(activeNode)) return categoryList.emptyNode.category
      if (isAudio(activeNode)) return categoryList.audio.category
      return ''
    },
  },

  mutations: {
    /**
     * @param category {string}
     * @param action {string} 枚举值有 add、update
     * @param subCategory {string} 子分类，枚举值有 bg：背景图片
     */
    openDialog(state, { category, action, subCategory = '', onReplaced } = {}) {
      // 没有组件库能力的项目不显示组件库
      if (
        !hasWidgetLib() &&
        categoryList.playUnit.tabList.some((item) => item.key === 'widgetLib')
      ) {
        categoryList.playUnit.tabList = categoryList.playUnit.tabList.filter(
          (item) => item.key !== 'widgetLib',
        )
      }
      if (['commonResource', 'resourcePool'].includes(category)) {
        state.dialog.visible = false
        state.libDialog.visible = true
        category && (state.currentCategory = categoryList[category].tabList[0])
      } else {
        state.libDialog.visible = false
        state.dialog.visible = true
        category && (state.currentCategory = categoryList[category])
        // 停车组件替换资源时弹窗里的项目资产tab放在最前面
        // if (state.poolTabData.parkResourceReplace) {
        //   const temp = state.currentCategory.tabList.pop()
        //   state.currentCategory.tabList.unshift(temp)
        // }
      }
      action && (state.action = action)
      state.subCategory = subCategory
      state.onReplaced = onReplaced
      // 如果是粒子里的图片
      if (isParticleImage(state.currentCategory.category, state.subCategory)) {
        state.currentCategory.tabList = imageTabList
      }
      // 展开弹窗时，选择 tab 列表的第一个 tab
      state.currentTab = state.currentCategory.tabList[0]
    },

    openInLib(state, { category, action, type }) {
      category && (state.currentCategory = categoryList[category])
      action && (state.action = action)
      if (type === 'common') {
        state.currentTab = state.currentCategory.tabList.find((item) => {
          return !item.type
        })
      } else if (type === 'asset') {
        state.currentTab = state.currentCategory.tabList.find((item) => {
          return item.type === 1
        })
      }
    },

    openResourcePoolDialog(state) {
      state.resourcePoolDialog.visible = true
    },

    openIvUnitDialog(state) {
      state.ivUnitDialog.visible = true
    },

    openDebugDialog(state) {
      state.debugDialog.visible = true
    },

    updatePoolTabData(state, data) {
      state.poolTabData = data
    },

    assignPoolTabData(state, data) {
      state.poolTabData = {
        ...state.poolTabData,
        ...data,
      }
    },

    closeDialog(state) {
      state.dialog.visible = false
    },
    closeLibDialog(state) {
      state.libDialog.visible = false
      // 关闭弹窗重置数据
      state.poolTabData = {
        ...defaultPoolTabData,
      }
    },
    closeResourcePoolDialog(state) {
      state.resourcePoolDialog.visible = false
    },

    closeIvUnitDialog(state) {
      state.ivUnitDialog.visible = false
    },
    closeDebugDialog(state) {
      state.debugDialog.visible = false
    },

    resetState(state) {
      // 如果打开的是资源池的数据，不重置数据
      if (state.libDialog.visible) {
        return
      }
      Object.assign(state, {
        ...getInitState(),
        // tagList 不需要重置
        tagList: state.tagList,
        assistTag: state.assistTag,
        freeSize: state.freeSize,
        totalSize: state.totalSize,
        usedSize: state.usedSize,
        totalAssets: state.totalAssets,
        libDialog: state.libDialog,
        poolTabData: state.poolTabData,
        resourcePoolDialog: state.resourcePoolDialog,
        resourceToNodePool: state.resourceToNodePool,
        ivUnitDialog: state.ivUnitDialog,
      })
    },

    moveDialogToRight(state) {
      state.dialogStyle = {
        right: 'calc(641px - 100vw)',
        left: 'auto',
      }
    },

    moveDialogToLeft(state) {
      state.dialogStyle = {
        right: 'auto',
        left: '241px',
      }
    },
    moveLibDialogToRight(state) {
      state.libDialogStyle = {
        right: 'auto',
        left: '241px',
      }
    },
    moveLibDialogNextToRight(state) {
      state.libDialogStyle = {
        right: 'calc(641px - 100vw)',
        left: 'auto',
      }
    },
    moveLibDialogToLeft(state) {
      state.libDialogStyle = {
        right: 'auto',
        left: '560px',
      }
    },

    setXlzCache(state, { key, value }) {
      state.xlzCache[key] = value
    },

    updateKeyword(state, value) {
      state.query.keyword = value
    },

    updateFilterSearchTag(state, value) {
      state.filterSearchTag = value
    },

    updateComponentsTitle(state, { name, id }) {
      state.currentCommonComponentsInfo = {
        name,
        id,
      }
    },

    updateSearchTagId(state, value) {
      state.searchTagId = value
    },

    updateSearchTagType(state, value) {
      state.searchTagType = value
    },

    updateAssetsDialog(state, data) {
      Object.assign(state.assetsDialog, data)
    },

    updateResourcePool(state, data) {
      state.resourceToNodePool = data
    },

    setUsage(state, { free_size, total_size, used_size, total_assets }) {
      state.freeSize = free_size
      state.totalSize = total_size
      state.usedSize = used_size
      state.totalAssets = total_assets
    },

    updateForbiddenFontDialog(state, data) {
      Object.assign(state.forbiddenFontDialog, data)
    },

    updateReplaceResourcePoolItem(state, data) {
      state.replaceResourcePoolItem = data
    },
  },

  actions,
}
